<template>
  <v-card color="#f2eee7" :loading="loading">
    <div style="max-height: 600px; overflow-y: scroll;" ref="messagesContainer">
      <div style="display:flex; flex-direction:column; width:100%;padding:5px;">
        <div v-for="(message, m) in po.messages" 
            :key="'message-'+m" 
            class="messageContainer"
            :style="{
              'margin-left': message.me ? 'auto' : '0', 
              'margin-right': message.me ? '0' : 'auto',
              'background': message.me ? '#d9fdd3' : '#fff'
            }">
          <div v-if="message.message && !message.attachment_url">
            {{message.message}}
          </div>
          <div v-if="message.attachment_url">
            <span v-if="determineFileType(message.attachment_url) === 'image'">
              <img :src="message.attachment_url" width="100%">
            </span>
            <span v-if="determineFileType(message.attachment_url) === 'video'">
              <video :src="message.attachment_url" width="100%" controls></video>
            </span>
            <span v-if="determineFileType(message.attachment_url) === 'file'">
              <v-btn :href="message.attachment_url" target="_blank" class="" color="blue" text block>
                <v-icon size="small" class="ml-1">open_in_new</v-icon>
                {{i18n["open_file"]}}
              </v-btn>
            </span>
          </div>
          <div style="font-size:9px;float: right;">
            {{message.user.name}} | {{message.created_at.split('.')[0].split('T').join(' ')}} {{message.is_platform ? '| NINJA SELLERS' : ''}}
          </div>
              <v-icon style="float:left;" :color="`${message.is_read?'#53bdeb':''}`" size="12">done_all</v-icon>
        </div>
      </div>
      <div class="text-center my-3">
        <v-btn color="success" :loading="loading" text small @click="loadMessages()">{{i18n['reload']}}</v-btn>
      </div>
    </div>
    
    <div>
      <v-textarea 
        filled 
        clearable 
        auto-grow 
        append-icon="reply" 
        prepend-inner-icon="image" 
        rows="1" 
        dense 
        v-model="message"
        hide-details
        :label="i18n['message']" 
        @click:append="sendMessage()" 
        @click:prepend-inner="pickFileImages()"
        :loading="uploadProgress>0"
        >
      </v-textarea>
      <input
        type="file"
        style="display: none"
        ref="fileImages"
        accept="image/*"
        @change="onFilePickedImages"
      >
    </div>
  </v-card>
</template>

<script>
import { firebase, store, db, auth, storageRef } from '@/fb';
import { randomString } from '@/customFunction';
export default {
  props:['po', 'loading'],
  data() {
    return {
      message:null,
      attachment:null,
      uploadProgress:0
    }
  },
  methods: {
    determineFileType(url) {
      const imageExtensions = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'svg', 'webp'];
      const videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv'];

      // Extract the pathname from the URL
      let pathname = new URL(url).pathname;
      // Decode URI to handle encoded characters
      pathname = decodeURIComponent(pathname);

      // Extract the file extension
      const match = pathname.match(/\.([0-9a-z]+)(?:[\?#]|$)/i);
      let extension = match ? match[1].toLowerCase() : null;

      if (imageExtensions.includes(extension)) {
        return 'image';
      } else if (videoExtensions.includes(extension)) {
        return 'video';
      } else {
        return 'file';
      }
    },
    pickFileImages(){
      this.$refs.fileImages.click()
    },
    loadFileImages(file, type, ext){
      var file = file
      var metadata = {
        contentType: type
      };
      var uploadTask = storageRef.child('images/ninja/whatsapp/attachments' + randomString(8, 'Aa#') + '.' + ext).put(file, metadata);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        (snapshot)=> {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
					  this.uploadProgress = progress
          }, (error) =>{
          console.log(error);

        switch (error.code) {

          case 'storage/unauthorized':
            break;
          case 'storage/canceled':
            break;
          case 'storage/unknown':
            break;
        }
      },() => {
        uploadTask.snapshot.ref.getDownloadURL().then(async (downloadURL) =>{
					this.uploadProgress = 0
          this.attachment = downloadURL
          await this.sendMessage();
          console.log(downloadURL)
        });
      });
    },
    onFilePickedImages (e) {
      const files = e.target.files
      if(files[0] !== undefined) {
        const fr = new FileReader ()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.file = files[0] // this is an image file that can be sent to server...
          this.loadFileImages(this.file, this.file.type, this.file.name.split('.').pop())
        })
      } else {
        this.name = null
        this.uploadURL = null
      }
    },
    async sendMessage() {
			const r = await this.$store.dispatch('postResource', { resource: '/purchase-orders/message', value: {purchase_order_id:this.$props.po.id, message:this.message, attachment_url:this.attachment} })
      this.$store.dispatch('setSnackbar', { type:r.success?'success':'error', message:this.i18n[r.message] })
      this.message = null
      this.attachment = null
      this.$emit('reloadData')
    },
    async loadMessages() {
      console.log(this.$props.po)
      this.$emit('reloadData')
      this.scrollToBottom();
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messagesContainer;
        container.scrollTop = container.scrollHeight;
      });
    }
  },
  computed:{
    language() {
      return this.$store.state.language;

    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar")
        return true;
    },
  },
  async created() {
    await this.loadMessages()
  },
  async mounted() {
    this.scrollToBottom();
  },
}
</script>

<style>
.messageContainer {
  width: 45%;
  margin-bottom: 4px;
  border-radius: 4px;
  border-color: #c2bfbf;
  padding: 4px 8px;
  box-shadow: 0 1px 0.5px rgba(0, 0, 0,.13);
}
</style>